module.exports = __webpack_public_path__ + "img/teacher1-2.579f01ea.png";